module.exports = __webpack_public_path__ + "img/ltkfindsunder100-1x.7bf726e.jpg";